<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    /*
     * O TOM DOS PONTOS SE ESCOLHE PELO FUNDO EM QUE ELES CAEM, não pelo componente
     * que os hospeda: `light` para fundo escuro, `dark` para fundo claro ou de cor
     * saturada, e o padrão (nulo) para o fundo da página. Quem decide o par está em
     * Button.vue, que tem a medida de contraste de cada cor de botão anotada.
     */
    variant: {
      type: String,
      default: null,
      required: false,
      validator(value) {
        return [null, 'light', 'dark'].includes(value);
      },
    },
  });

  const classes = computed(() => ({
    'credere-spinner': true,
    'variant--light': props.variant === 'light',
    'variant--dark': props.variant === 'dark',
  }));
</script>

<template>
  <span :class="classes">
    <span
      v-for="i in 3"
      :key="i"
      class="credere-spinner-bullet"
    />
  </span>
</template>

<style lang="scss">
  .credere-spinner {
    --spinner-bullet: var(--cordel-spacing-mini);
    --spinner-margin: var(--spinner-bullet);

    /*
      A raiz é um `<span>`, e um `<span>` é `inline` - onde largura e altura não valem
      nada. A caixa então media zero, e os três pontos, todos absolutos, transbordavam
      para fora dela: dentro do Button e do EmptyState isso não aparecia (item de flex é
      blocado pelo navegador, e a caixa ganhava tamanho por tabela), mas em qualquer
      contexto de texto o que sobrasse do fundo em volta cortava os pontos.
    */
    display: inline-block;
    height: calc(var(--spinner-bullet) * 2);
    position: relative;
    width: calc(var(--spinner-bullet) * 3 + var(--spinner-margin) * 2);
  }

  @keyframes credere-spinner {
    0% { transform: translateY(calc(var(--spinner-bullet) / -2)); opacity: 1; }
    50% { transform: translateY(calc(var(--spinner-bullet) / 2)); opacity: 0.5; }
    100% { transform: translateY(calc(var(--spinner-bullet) / -2)); opacity: 1; }
  }

  .credere-spinner-bullet {
    --background-color: var(--cordel-color-neutral-primary);
    --border-radius: 100%;

    animation: credere-spinner 1s infinite;
    height: var(--spinner-bullet);
    left: 0;
    position: absolute;
    top: calc(50% - var(--spinner-bullet) / 4);
    width: var(--spinner-bullet);

    .variant--light & {
      --background-color: var(--cordel-color-constant-light);
    }

    .variant--dark & {
      --background-color: var(--cordel-color-constant-dark);
    }

    /*
      `nth-child` conta a partir de 1 e a posição a partir de 0 - o primeiro ponto é o que
      não anda nem atrasa. Escrito como `from 0 through 2`, o laço gastava uma volta em
      `:nth-child(0)`, que não casa com elemento nenhum, e o terceiro ponto ficava sem regra
      alguma: atraso zero e `left: 0`, empilhado embaixo do primeiro. Três pontos no DOM e
      dois na tela.
    */
    @for $index from 1 through 3 {
      &:nth-child(#{$index}) {
        animation-delay: ($index - 1) * 0.2s;
        left: calc((var(--spinner-bullet) + var(--spinner-margin)) * #{$index - 1});
      }
    }
  }
</style>
